import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetail } from "@/components/ServiceDetail";
import { serviceGraph, abs } from "@/lib/serviceSchema";
import { serviceFaqs } from "@/data/serviceFaqs";
import img from "@/assets/climate-control.jpg";

const bullets = [
  "Professionally installed smart thermostats with custom programming",
  "Multi-zone HVAC control",
  "Whole-home humidification and dehumidification",
  "Geofencing and occupancy-based scheduling",
  "Integration with your lighting, shading, and automation platform",
  "Remote monitoring with energy use reporting",
];

export const Route = createFileRoute("/services/climate-control")({
  head: () => ({
    meta: [
      { title: "Smart Climate Control Installation | Apex AV Denver" },
      { name: "description", content: "Smart thermostat, zoning, and HVAC integration for Denver homes. Professional installs that talk to your lighting, shades, and automation system." },
      
      { name: "keywords", content: "smart thermostat installation Denver, smart climate control Denver, HVAC automation Denver, multi-zone HVAC Denver, thermostat integration Denver, humidity control Denver, home climate automation Denver, energy saving thermostat Denver, smart home HVAC Denver, Denver climate control installer" },
      { property: "og:title", content: "Smart Climate Control — Apex AV Denver" },
      { property: "og:description", content: "Smart thermostats, multi-zone HVAC, and integrated climate automation in Denver." },
      { property: "og:image", content: abs(img) },
      { name: "twitter:image", content: abs(img) },
      { property: "og:url", content: "https://apexav.com/services/climate-control" },
      { property: "og:type", content: "website" },
      { name: "twitter:title", content: "Smart Climate Control — Apex AV Denver" },
      { name: "twitter:description", content: "Smart thermostats, multi-zone HVAC, and integrated climate automation in Denver." },
    ],
    links: [{ rel: "canonical", href: "https://apexav.com/services/climate-control" }, { rel: "preload", as: "image", href: img, fetchPriority: "high" } as never],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          serviceGraph({
            slug: "climate-control",
            name: "Smart Climate Control",
            description: "Smart thermostats and multi-zone HVAC integration in Denver.",
            pageTitle: "Smart Climate Control Installation | Apex AV Denver",
            pageDescription: "Smart thermostat, zoning, and HVAC integration for Denver homes. Professional installs that talk to your lighting, shades, and automation system.",
            image: img,
            faqs: serviceFaqs["climate-control"],
            serviceType: "Smart Climate Control",
            breadcrumbName: "Smart Climate Control Denver",
            offerCatalog: bullets,
          })
        ),
      },
    ],
  }),
  component: () => (
    <ServiceDetail
      topics={["smart-home", "lighting", "networking"]}
      eyebrow="Smart climate"
      title="Climate that knows your day."
      intro={<>Professional <strong>smart thermostat installation in Denver</strong>, <strong>multi-zone HVAC control</strong>, and humidity management that adapts to occupancy, weather, and routines — fully integrated with lighting, shades, and security.</>}
      image={img}
      imageAlt="Smart climate control thermostat and zoned HVAC installation in a Littleton Denver home"
      brands={["ecobee"]}
      bullets={bullets}
      features={[
        { title: "Energy savings", desc: "Smart scheduling and zoning typically cut Denver heating and cooling bills by 15–25%." },
        { title: "One scene, one tap", desc: "'Goodnight' lowers temps, dims lights, and arms security in a single command." },
        { title: "Front Range tuned", desc: "Configured for Denver's dramatic temperature swings and dry winter air." },
      ]}
      faqs={serviceFaqs["climate-control"]}
    />
  ),
});
